import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneNameField');

    return {
        DRONE_NAME_FIELD_LABEL: t('droneNameFieldLabel')
    };
};

export default useTranslation;
